var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(7 2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC900",
    d: "M5 0c1.84 0 3.333 1.492 3.333 3.333v7.94C9.356 12.19 10 13.52 10 15c0 2.761-2.239 5-5 5s-5-2.239-5-5c0-1.48.644-2.811 1.667-3.727v-7.94C1.667 1.493 3.159 0 5 0zm0 1.667c-.92 0-1.667.746-1.667 1.666v8.685l-.555.497c-.703.63-1.111 1.523-1.111 2.485 0 1.84 1.492 3.333 3.333 3.333 1.84 0 3.333-1.492 3.333-3.333 0-.962-.407-1.855-1.111-2.485l-.555-.497V3.333c0-.92-.746-1.666-1.667-1.666zm.833 5v5.975C6.805 12.986 7.5 13.912 7.5 15c0 1.38-1.12 2.5-2.5 2.5S2.5 16.38 2.5 15c0-1.088.696-2.014 1.666-2.358V6.667h1.667z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemp);
export default __webpack_public_path__ + "static/media/temp.51b7c662fbbe28f3b54c008efa570235.svg";
export { ForwardRef as ReactComponent };